import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { highRiskDefinition } from '../../fields.utils';
import { Term, Tip } from './HighRiskTerm.styles';

const EDGE_PX = 8;
let nextId = 0;

export const HighRiskTerm = ({ mustPickCm, children = 'High risk' }) => {
  const idRef = useRef(null);
  if (idRef.current === null) idRef.current = `high-risk-tip-${nextId++}`;
  const tipRef = useRef(null);
  const [anchor, setAnchor] = useState(null);
  const [place, setPlace] = useState(null);

  useLayoutEffect(() => {
    if (!anchor || !tipRef.current) {
      setPlace(null);
      return;
    }
    const { offsetWidth: width, offsetHeight: height } = tipRef.current;
    const left = anchor.left + anchor.width / 2 - width / 2;
    const x = Math.min(Math.max(EDGE_PX, left), window.innerWidth - width - EDGE_PX);
    const below = anchor.bottom + EDGE_PX;
    const y =
      below + height > window.innerHeight - EDGE_PX
        ? anchor.top - height - EDGE_PX
        : below;
    setPlace({ x, y });
  }, [anchor]);

  useEffect(() => {
    if (!anchor) return undefined;
    const close = () => setAnchor(null);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [anchor]);

  const open = event => setAnchor(event.currentTarget.getBoundingClientRect());
  const close = () => setAnchor(null);

  return (
    <>
      <Term
        tabIndex={0}
        aria-describedby={anchor ? idRef.current : undefined}
        onMouseEnter={open}
        onMouseLeave={close}
        onFocus={open}
        onBlur={close}
        onClick={event => {
          event.preventDefault();
          open(event);
        }}
        onKeyDown={event => event.key === 'Escape' && close()}
      >
        {children}
      </Term>
      {anchor &&
        createPortal(
          <Tip
            ref={tipRef}
            id={idRef.current}
            role='tooltip'
            style={{
              left: place?.x ?? 0,
              top: place?.y ?? 0,
              visibility: place ? 'visible' : 'hidden'
            }}
          >
            {highRiskDefinition(mustPickCm)}
          </Tip>,
          document.body
        )}
    </>
  );
};
